require('normalize.css/normalize.css');
require('styles/App.css');

import React from 'react';

import FormItemUtil from '../utils/FormItemUtil';
import CommandResolver from '../utils/CommandResolver';
import CommandHelper from '../remote/CommandHelper';
import ServiceHelper from '../remote/ServiceHelper';
import FormDataSources from '../datasource/FormDataSources';

import GOTUtil from '../utils/GOTUtil';
import QueryUtil from '../utils/QueryUtil';
import CommonUtil from '../utils/CommonUtil';
import FormResourceUtil from '../utils/FormResourceUtil';
import StringUtil from '../utils/StringUtil';
import LookupRefreshStore from '../stores/LookupRefreshStore';
import LookupActions from '../actions/LookupActions';
import DomActions from '../actions/DomActions';


class FormModuleLookup extends React.Component{

	
  constructor(props)
  {
  	super(props);
    this.entityId = props.entityId;
    this.innerId = props.innerId;
    this.instanceUUId = CommonUtil.guid(); 
    this.classAlias = "FormModuleLookup";
    this.autoReturn = true;
    //this.formDataSources = new FormDataSources(this.props.xml.FormDataSources,this,true);
    //console.log(this.formDataSources);
    this.formXML = props.xml;
    this.formId = this.props.formId;
    this.menuItemId = this.props.menuItemId;
    this.formName = "Form_"+this.props.xml.name;
    //new FormDataSources中 要构建FormDataSourceGroup 会反过来找formId menuItemId等基础属性，所以
    //创建FormDataSources要放在基础属性赋值完毕
    this.formDataSources = new FormDataSources(this.props.xml.FormDataSources,this,true);
    FormItemUtil.initFormItemControls(this.props.menuItemId,this.props.formId,this.props.xml,this.props.xml.FormDesign,this.formDataSources,true);
  

    this.unsubscribeLookupCmpStore = 
    LookupRefreshStore.listen(this.onDataProviderRefresh.bind(this));

    var ds = props.xml.FormDataSources;
    var returnTable = GOTUtil.getPropertyValue(ds,"ReturnTable");
    var returnField = GOTUtil.getPropertyValue(ds,"ReturnField");
    this.returnTable = null;this.fieldName = null;this.returnField = null;
    if(returnTable == "" || returnField == "")
    {
      this.autoReturn = false;  
    }
    else
    {
      this.returnTable = returnTable;
      this.fieldName = returnField;
      this.returnField = returnTable + "." + returnField.substr(0,1).toLowerCase() + returnField.substr(1);
    }

    this.doLookupRefresh = this.doLookupRefresh.bind(this);
    this.lookupReturnServer = this.lookupReturnServer.bind(this);
    this.formLabel = "";
    this.contextMap = {remoteClass:"java.util.HashMap"};
    if(this.props.isPop)
    {
      var helperGroup = this.formDataSources?this.formDataSources.firstGroup:null;
      var _label = GOTUtil.getLabelByForm(this.props.xml,helperGroup,this.menuItemId);
      this.formLabel = _label;
    }
    //console.log(FormItemUtil.formItemControls);
  }

  updatePosition()
  {
    var $parent = $("#"+this.formName).parent();
    var _left = $parent.position().left;
    var _width = $parent.width();
    var max_Width = $(window).outerWidth(true);
    var diff = max_Width - (_left+_width);
    if(diff<0)
    {
      let newLeft = _left+diff-10;
      if(newLeft<0)newLeft = 0;
      $parent.css('left',newLeft+'px');
    }
  }

  componentWillMount()
  {
    var mi = FormResourceUtil.getCommandArgMethodInfo("beforeInit","FormLookup",this.props.formId);
    //var mi = FormResourceUtil.getCommandArgMethodInfo("afterInit","FormLookup",this.props.formId);
    if(mi)
    {
      if(!this.formDataSources)
        var group = null
      else
        group = this.formDataSources.firstGroup;
      
      if(mi.prefetch==true)
      {
        if(mi.commandResult)
          CommandResolver.resolve(mi.commandResult.tasks, this, group);
      }
      else
      {
        var arg = CommandResolver.getSendCmd(this, group==null?null:group.groupAlias, mi);
        
        var command = CommandHelper.createFormInstance(this.formName,"doBeforeInit","CommandResult");
        command.appendArg(arg,"CommandArg");
        
        var fm = this;
        var remoteArg = {command:command,resultFunction:function(data){CommandResolver.resolve(data.result.tasks, fm, group);}};
        ServiceHelper.addTokenWithCommand(remoteArg);
      }
    }
  }

  componentWillUnmount()
  {
    this.unsubscribeLookupCmpStore();
    this.formDataSources.componentWillUnmount();
  }


  addRecord()
  {
	 Actions.addRecord('3333');
  }

  beforeClose()
  {
    //let canvas = $(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Canvas")[0];
    //if(canvas)canvas.scrollTop=0;
    DomActions.lookupBeforeClose(this.entityId,this.innerId);
  }

  onDataProviderRefresh(entityId,innerId)
  {
    if(this.entityId != entityId || this.innerId != innerId)
      return;

    var mi = FormResourceUtil.getCommandArgMethodInfo("afterInit","FormLookup",this.props.formId);
    if(mi!=null)
    {
      var group;
      if(this.formDataSources!=null)
      {
        group = this.formDataSources.firstGroup; 
      }
      
      if(mi.prefetch==true)
      {
        CommandResolver.resolve(mi.commandResult.tasks, this);
      }
      else
      {
        
        var arg = CommandResolver.getSendCmd(this, group==null?null:group.groupAlias, mi);
        
        var command = CommandHelper.createFormInstance(this.formName,"doAfterInit","CommandResult");
        command.appendArg(arg,"CommandArg");
        
        var fm = this;
        var remoteArg = {command:command,resultFunction:function(data){
                                                          if(data && data.result)
                                                          {
                                                              CommandResolver.resolve(data.result.tasks,fm,group);
                                                          }
                        },sync:false};
        ServiceHelper.addTokenWithCommand(remoteArg);
      }
    }
  }
  
  //TODO 是否同步 来自命令
  doLookupRefresh(task)
  {
    var _group;
    if(this.autoReturn==true)
    {
      _group = this.formDataSources.groups[this.returnTable];
      if(!_group && this.formDataSources.sources)
      {
        var source = this.formDataSources.sources[this.returnTable];
        if(source)
          _group = source.group;
      }
    }
    else
    {
      _group = CommandResolver.getTaskGroup(task,this);
    }
    
    var _alias;
    if(_group)
      _alias = _group.groupAlias;
    
    var methodName = "lookupRefresh";
    
    var argInfo = FormResourceUtil.getCommandArgMethodInfo(methodName,"FormLookup",this.formId);
    var cmdarg = argInfo==null?null:CommandResolver.getSendCmd(this,_group==null?null:_group.groupAlias,argInfo);
    var groupAlias;var baseTableName;var baseRecord;var filterFieldName;var baseFilter;
    
    var queryTable;var dataPaging;var pageSize;var fieldName = this.fieldName;
    
    if(!_group)
    {
      groupAlias = null;
      queryTable = null;
      dataPaging = false;
      pageSize = 0;
    }
    else
    {
      groupAlias = _group.groupAlias;
      queryTable = QueryUtil.convertXML2QueryTable(_group.formQuery);
      dataPaging = !_group.mainSource.fetchAll;
      pageSize = _group.dataPageSize;
    }
   
    baseTableName = this.lookupArg["baseTableName"];
    baseRecord = this.lookupArg["baseRecord"];
    filterFieldName = this.lookupArg["filterFieldName"];
    baseFilter = this.lookupArg["baseFilter"];
    
    try {
        if(_group && filterFieldName && baseFilter && baseFilter.indexOf("*") != -1){
          QueryUtil.findOrCreateWhereItemByField(this.lookupArg["fieldName"],this.lookupArg["fieldName"],queryTable.aliasName,_group.formQuery,baseFilter);
          }
          if(_group)
          {
            queryTable = QueryUtil.convertXML2QueryTable(_group.formQuery);
          }
    } catch (error) {
      
    }
 

    
    
    var command = CommandHelper.createFormInstance(this.formName,"doLookupRefresh","Object");
    command.appendArg(cmdarg,"CommandArg")
      .appendArg(_alias)
      .appendArg(this.fieldName)
      
      .appendArg(baseTableName)
      .appendArg(baseRecord, "Object")
      .appendArg(filterFieldName)
      .appendArg(baseFilter)
      
      .appendArg(queryTable, "QueryTable")
      .appendArg(dataPaging, "boolean")
      .appendArg(pageSize, "int");
    var that = this;
    var resultFunction = function(data)
    {
      var obj = data.result;
      if(!obj)return;
      if(obj.hasOwnProperty("commandResult"))
      {
        var fr = obj;
        if(fr.commandResult && fr.commandResult.tasks && fr.commandResult.tasks.length>0)
        {
          CommandResolver.resolve(fr.commandResult.tasks,this);
        }
        
        _group.reSetCurrentQuery();
        _group.rpc_result_executeQuery(data, _group.currentQuery.direction, false);
        
        
      }
      else if(obj.hasOwnProperty("tasks"))
      {
        CommandResolver.resolve(obj.tasks,that);
      }
    };
    var remoteArg = {command:command,resultFunction:resultFunction};
    ServiceHelper.addTokenWithCommand(remoteArg);
  }

  componentDidMount() 
  {
    //alert($("#app").width() + "   " + $("#app").height());
    for(var key in this.formDataSources.groups)
    {
      let group = this.formDataSources.groups[key];
      group.initFormQuery();
      group.initCurrentQuery();
    }
  }

  findGroupBySourceName(source)
  {
    for(let key in this.formDataSources.groups)
    {
      var group = this.formDataSources.groups[key];
      for(let i=0;i<group.sources.length;i++)
      {
        let ds = group.sources[i];
        if(ds.alias == source)
          return group;
      }
    }
    return null;
  }

  castLookupReturnFields(returnFields)
  {
    for(let i=0;i<returnFields.length;i++)
    {
      var flrf = returnFields[i];
      var group = this.findGroupBySourceName(flrf.fromGroupAlias);
      if(!group)
        group = this.formDataSources.currentGroup;
      if(!group)
        group = this.formDataSources.firstGroup;
      if(!group)
        continue;
      var fromRecord = group.currentRecord;
      var _from = group.groupAlias+"."+StringUtil.convertToEachFirstLowerCase(flrf.fromDataField);
      flrf.fromValue = fromRecord[_from];
    }
    return returnFields;
  }

  lookupReturnServer(data)
  {
    if(!data)
      return;
    var obj = data;
    if(Array.isArray(obj) == true&&obj.length>0)
    {
      obj = this.castLookupReturnFields(obj);
    }
    LookupActions.lookupReturn(obj,this.props.entityId,this.props.innerId);
  }

  autoReturnHandler(obj)
  {
    //for LookupServerSpecify
    if(this.returnFields && this.returnFields.length>0)
    {
      var _returnFields = this.castLookupReturnFields(this.returnFields);
    }
    else if(this.returnField)
    {
      var returnValue = obj[this.returnField];
      LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);

    }
  }

  render() {
    let key = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,"FormDesign");
    let control = FormItemUtil.getFormItemControl(key,true);
    let formItemDesign = control.getComponentInstance(this.props.xml,true,
                              this.formLabel,this.formName,this.props.isPop,this.entityId,this.innerId);
    return(
      formItemDesign
    );
  }
};

FormModuleLookup.defaultProps = {
};

export default FormModuleLookup;




// WEBPACK FOOTER //
// ./src/components/FormModuleLookup.js